// extracted by mini-css-extract-plugin
export default {"Title":"Uz8lKkLN6qA7aef1Qj_S","Form":"eKas8h0dAGykPN2p52No","ButtonContainer":"M8Tn16nIVSPL8eo_hgx8","DisconnectButton":"CYjHxzesn_8cxTqgP0tG"};